import clsx from "clsx";
import * as React from "react";
import { ICheckboxProps } from ".";

const Checkbox: React.FC<ICheckboxProps> = ({ label, classes = {}, ...props }) => {
    return (
        <label className={clsx(classes.container, "tmp-checkbox")}>
            <input
                className={clsx(classes.checkbox, "tmp-checkbox__input")}
                type="checkbox"
                {...props}
            />
            {label || props.children}
        </label>
    );
};

export default Checkbox;
